import { ClientEnvironment, ClientEnvironmentName } from '~/core/types/environment';

export const environment: ClientEnvironment = {
	production: false,
	sentryDSN: 'https://274232054139476297ca200f86c67062@o309455.ingest.sentry.io/5937593',
	environmentName: ClientEnvironmentName.DEVELOPMENT,
	clientId: 'default',
	frontendUrl: 'https://dashboard.check.rea.ch',
	clientUrl: 'https://mobile.check.rea.ch',
	apiBaseUrl: 'https://api.check.rea.ch/',
	socialSignIn: {
		googleClientId: '106184129344-iphm6q5ab9tvvhq00gvmsb3f16kie2uo.apps.googleusercontent.com',
		appleClientId: 'ch.rea.app.signinweb',
		microsoftClientId: '3361613e-b173-498c-978f-20d709e6a56b',
		microsoftAuthority: 'common',
	},

	landingUrl: 'https://myreach.io',

	zapierAppLink:
		'https://zapier.com/developer/public-invite/165875/a14a7936576ebd99c12aee19f43b25e3/',

	imageCdn: 'https://images.weserv.nl/',

	googleMapsApiKey: 'AIzaSyC0Ui4mSH5zJgaabV6_FSzm4IGl57m0goI',

	handbookUrl: 'https://handbook.dev.rea.ch/',

	organizationDashboardUrl: 'https://manage.check.rea.ch',
};
